import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0dde709b"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dde709b')) {
      api.createRecord('0dde709b', component.options)
    } else {
      api.reload('0dde709b', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0dde709b", function () {
      api.rerender('0dde709b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reservation/list.vue"
export default component.exports